import {
  getProductView_productDetailByMasterId_composition,
  getProductView_productDetailByMasterId_variants,
} from '@containers/ProductDetailContainer/queries/__generated__/getProductView';
import { isEmpty } from '@helpers/utils';

interface IGetDescriptionIndex {
  description: string;
  composition: getProductView_productDetailByMasterId_composition[];
  variant: getProductView_productDetailByMasterId_variants;
}
export const getDescriptionIndex = ({
  description,
  composition,
  variant,
}: IGetDescriptionIndex) => {
  if (!isEmpty(description)) {
    return 'prodDescription';
  } else if (composition.length > 0 || variant.characteristics.length > 0) {
    return 'compositionPerfume';
  }
  return '';
};
